import { render, staticRenderFns } from "./change-detail.vue?vue&type=template&id=068b6362&scoped=true"
import script from "./change-detail.vue?vue&type=script&lang=js"
export * from "./change-detail.vue?vue&type=script&lang=js"
import style0 from "./change-detail.vue?vue&type=style&index=0&id=068b6362&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b6362",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('068b6362')) {
      api.createRecord('068b6362', component.options)
    } else {
      api.reload('068b6362', component.options)
    }
    module.hot.accept("./change-detail.vue?vue&type=template&id=068b6362&scoped=true", function () {
      api.rerender('068b6362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/express/components/change-detail.vue"
export default component.exports